module.exports = __webpack_public_path__ + "img/borrar.c16d4914.svg";